import { hashCode, myReplacer } from "src/components/js/statics1";
// eslint-disable-next-line import/no-cycle
import keikkaEval from "./keikkaEval";
import { keikkaLaskuRivi_delete } from "./KeikkaLaskuRiviFunctions";

export default class keikkaLaskuRiviClass {
  keikkaLaskuRiviId = null;
  keikkaId = null;
  keikkaLaskuId = null;
  keikkaLaskuPohjaId = null;
  keikkaLaskuPohjaRiviId = null;
  aktiivinen = true;
  ehtoKaava = "{true}";
  ehtoTäyttyy = true;
  riviSelite = null;
  riviSeliteKaava = null;
  riviSelite2 = null;
  riviSelite2Kaava = null;
  memo = null;
  määräKaava = null;
  määrä = null;
  yksikkö = null;
  hintaKaava = null;
  hinta = null;
  sortNum = null;
  tuoteId = null;
  tuoteIdKaava = null;
  helpId = null;
  alv = import.meta.env.VITE_DEFAULT_ALV_PROM / 100;
  laskuttajaAsiakasId = null;
  maksajaAsiakasId = null;
  isLaskutettu = false;
  laskutettuTime = null;
  laskuNo = 0;
  alennus = 0;
  kustannusPaikka = null;

  constructor(keikkaId, keikkaLaskuId) {
    this.keikkaLaskuRiviId;
    this.keikkaId = keikkaId;
    this.keikkaLaskuId = keikkaLaskuId;
    this.keikkaLaskuPohjaId;
    this.keikkaLaskuPohjaRiviId;
    this.aktiivinen;
    this.ehtoKaava;
    this.ehtoTäyttyy;
    this.riviSelite;
    this.riviSeliteKaava;
    this.riviSelite2;
    this.riviSelite2Kaava;
    this.memo;
    this.määräKaava;
    this.määrä;
    this.yksikkö;
    this.hintaKaava;
    this.hinta;
    this.sortNum;
    this.tuoiteId;
    this.tuoteIdKaava;
    this.helpId;
    this.alv;
    this.laskuttajaAsiakasId;
    this.maksajaAsiakasId;
    this.isLaskutettu;
    this.laskutettuTime;
    this.laskuNo;
    this.alennus;
    this.kustannusPaikka;
  }

  initByPohjaRivi(keikkaLaskuPohjaRivi, keikkaData, toimitus) {
    this.keikkaLaskuPohjaId = keikkaLaskuPohjaRivi.keikkaLaskuPohjaId;
    this.keikkaLaskuPohjaRiviId = keikkaLaskuPohjaRivi.keikkaLaskuPohjaRiviId;
    this.aktiivinen = keikkaLaskuPohjaRivi.aktiivinen;
    this.ehtoKaava = keikkaLaskuPohjaRivi.ehtoKaava;
    this.riviSelite = keikkaLaskuPohjaRivi.riviSelite;
    this.riviSeliteKaava = keikkaLaskuPohjaRivi.riviSeliteKaava;
    this.riviSelite2 = keikkaLaskuPohjaRivi.riviSelite2;
    this.riviSelite2Kaava = keikkaLaskuPohjaRivi.riviSelite2Kaava;
    this.memo = keikkaLaskuPohjaRivi.memo;
    this.määräKaava = keikkaLaskuPohjaRivi.määräKaava;
    this.määrä = keikkaLaskuPohjaRivi.määrä;
    this.yksikkö = keikkaLaskuPohjaRivi.yksikkö;
    this.hintaKaava = keikkaLaskuPohjaRivi.hintaKaava;
    this.hinta = keikkaLaskuPohjaRivi.hinta;
    this.sortNum = keikkaLaskuPohjaRivi.sortNum;
    this.tuoteIdKaava = keikkaLaskuPohjaRivi.tuoteIdKaava;
    this.tuoteId = keikkaLaskuPohjaRivi.tuoteId;
    this.helpId = keikkaLaskuPohjaRivi.helpId;
    this.alv = keikkaLaskuPohjaRivi.alv;
    this.laskuttajaAsiakasId = keikkaLaskuPohjaRivi.laskuttajaAsiakasId;
    this.alennus = keikkaLaskuPohjaRivi.alennus;
    this.kustannusPaikka = keikkaLaskuPohjaRivi.kustannusPaikka;
    this.evaluateKaavat(keikkaData, toimitus);
  }

  json() {
    const replacerWrapper = (key, value) => myReplacer(key, value, "keikka");
    return JSON.stringify(this, replacerWrapper, 2);
  }

  get isPohja() {
    return !(this.keikkaLaskuId > 0) && this.keikkaLaskuPohjaId > 0;
  }
  get isLasku() {
    return this.keikkaLaskuId > 0 && !(this.keikkaLaskuPohjaId > 0);
  }
  get isUnknown() {
    return (!this.isPohja && !this.isLasku) || (this.isPohja && this.isLasku);
  }

  // async saveToDB(token) {
  //   const a = await KeikkaLaskuRivi_saveToDB(this, token);
  //   return a;
  // }
  async deleteFromDB(token) {
    return await keikkaLaskuRivi_delete(null, this.keikkaLaskuRiviId, token);
  }
  // evaluate all kaavat for this keikkaLaskuRivi
  evaluateKaavat(keikkaData, toimitus = null) {
    if (!keikkaData) return;
    this.määrä = keikkaEval(this.määräKaava, keikkaData, null, toimitus).result.num;
    if (this.määrä != 0)
      this.ehtoTäyttyy = keikkaEval(this.ehtoKaava, keikkaData, null, toimitus).result.bool;
    else this.ehtoTäyttyy = false;
    this.hinta = keikkaEval(this.hintaKaava, keikkaData, null, toimitus).result.num;
    this.tuoteId = keikkaEval(this.tuoteIdKaava, keikkaData, null, toimitus).result.string;
    this.riviSelite = keikkaEval(this.riviSeliteKaava, keikkaData, null, toimitus).result.string;
    this.riviSelite2 = keikkaEval(this.riviSelite2Kaava, keikkaData, null, toimitus).result.string;
  }

  get hash() {
    return hashCode(this.json());
  }
}
